<template>
  <div>
    <v-chip label small class="primary my-1" v-if="produto.$melhorFrete">
      {{ produto.frete.tipoFrete }}&nbsp;
      <span v-if="produto.frete.totalTransporte">
        ({{ produto.frete.totalTransporteConvertido | currency }})
      </span>
    </v-chip>
    <div v-else class="my-1">
      {{ produto.frete.tipoFrete }}
      <span v-if="produto.frete.totalTransporte">&nbsp;
        ({{ produto.frete.totalTransporteConvertido | currency }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    produto: Object,
  },
  computed: {
  },
};
</script>
